export const AppPermissions = {
  // Projects
  PROJECT_CREATE: 'core.project.create',
  PROJECT_LIST: 'core.project.list',
  PROJECT_UPDATE: 'core.project.update',
  PROJECT_DELETE: 'core.project.delete',

  // Trays
  TRAYS_READ: 'core.trays.read',
  TRAYS_UPDATE: 'core.trays.update',
  TRAYS_DELETE: 'core.trays.delete',

  // Devices
  DEVICES_LIST: 'core.devices.list',
  DEVICES_READ: 'core.devices.read',

  // Jobs
  JOBS_LIST: 'core.jobs.list',
  JOBS_READ: 'core.jobs.read',
  JOBS_CANCEL: 'core.jobs.cancel',
  JOBS_RERUN: 'core.jobs.rerun',
  JOBS_SUMMARY_READ: 'core.jobs.summary.read',

  // Job Templates
  JOBTEMPLATE_UPDATE: 'core.jobtemplate.update',
  JOBTEMPLATE_CLONE: 'core.jobtemplate.clone',
  JOBTEMPLATE_DELETE: 'core.jobtemplate.delete',
  JOBTEMPLATE_SELECT: 'core.jobtemplate.select',
  JOBTEMPLATE_CREATE: 'core.jobtemplate.create',

  // Suites & Snapshots
  SUITE_CREATE: 'core.suite.create',
  SUITE_READ: 'core.suite.read',
  SUITE_DELETE: 'core.suite.delete',
  SNAPSHOT_LIST: 'core.snapshot.list',
  SNAPSHOT_CREATE: 'core.snapshot.create',

  // Change Requests
  CHANGE_REQUEST_CREATE: 'core.change-request.create',
  CHANGE_REQUEST_LIST: 'core.change-request.list',
  CHANGE_REQUEST_READ: 'core.change-request.read',
  CHANGE_REQUEST_UPDATE: 'core.change-request.update',
  CHANGE_REQUEST_STATUS_UPDATE: 'core.change-request.status-update',

  // Test Case Management
  MODULE_CREATE: 'core.module.create ', // Note: space kept as per your JSON key
  TESTCASES_CREATE: 'core.testcases.create',
  TESTCASES_DELETE: 'core.testcases.delete',
  TESTCASES_READ: 'core.testcases.read',
  TESTCASES_EDIT: 'core.testcases.edit',
  TAGS_CREATE: 'core.tags.create',
  TESTDATA_CREATE: 'core.testdata.create',
  TESTDATA_DELETE: 'core.testdata.delete',

  // User Management
  USERS_CREATE: 'core.users.create',
  USERS_LIST: 'core.users.list',
  USERS_UPDATE: 'core.users.update',
  USERS_DELETE: 'core.users.delete',
  USERS_READ: 'core.users.read',

  // Admin
  ADMIN_PERMISSIONS_UPDATE: 'admin.permissions.update'
};

Object.freeze(AppPermissions);